import VaultHero from "../VaultHero";
import EventEmitter from './EventEmitter.js'

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

export default class Sizes extends EventEmitter {
    /**
     * Constructor
     */
    constructor() {
        super()

        this.experience = new VaultHero()
        this.targetElement = this.experience.targetElement
        this.originalWidth = 1680;
        this.originalHeight = 500;
        this.rem = 2 / this.originalHeight;
        this.originalAspectRatio = this.originalWidth / this.originalHeight;

        this.resize = this.resize.bind(this)
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this)
        this.debouncedHandleBreakpointChange = debounce(this.handleBreakpointChange, 100)

        // detect target element size changes with observer
        this.resizeObserver = new ResizeObserver(this.resize)
        this.resizeObserver.observe(this.targetElement)

        this.breakpoints = {
            isMobile: false,
            isTablet: false,
            isDesktop: false,
        }

        this.mobileBreakpoint = window.matchMedia('(max-width: 767px)');
        this.mobileBreakpoint.addEventListener('change', this.debouncedHandleBreakpointChange);

        this.tabletBreakpoint = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
        this.tabletBreakpoint.addEventListener('change', this.debouncedHandleBreakpointChange);

        this.resize()
        this.handleBreakpointChange()
    }

    handleBreakpointChange() {
        this.breakpoints.isMobile = !!this.mobileBreakpoint.matches;
        this.breakpoints.isTablet = !!this.tabletBreakpoint.matches;
        this.breakpoints.isDesktop = !this.breakpoints.isMobile && !this.breakpoints.isTablet;
        this.breakpoints.current = this.breakpoints.isMobile ? 'mobile' : (this.breakpoints.isTablet ? 'tablet' : 'desktop');

        this.trigger('breakpointChange')
    }

    fitToScene(item) {
        if (this.scale > 1) {
            if(this.scaleY < 1) {
                item.scale.set(1 / this.scaleY, 1 / this.scaleY, 1 / this.scaleY);
                item.position.x = 0;
            } else {
                item.scale.set(this.scale, this.scale, this.scale);
                item.position.x = 0;
            }
        } else {
            if(this.scaleY < 1) {
                item.scale.set(1 / this.scaleY, 1 / this.scaleY, 1 / this.scaleY);
                item.position.x = 0;
            } else {
                item.scale.set(1, 1, 1);
                const deltaX = (this.width - this.originalWidth) * this.rem;
                item.position.x = deltaX / 2;
            }
        }
    }

    /**
     * Resize
     */
    resize() {
        window.requestAnimationFrame(() => {
            this.resizeHandler()
        })
    }

    resizeHandler() {
        this.width = this.targetElement.offsetWidth
        this.height = this.targetElement.offsetHeight
        this.aspectRatio = this.width / this.height
        this.em = 2 / this.height;
        this.scale = this.width / this.originalWidth
        this.scaleY = this.height / this.originalHeight

        this.trigger('resize')
    }
}
